import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './CurtainsScene.scss'

export default class CurtainsScene extends Component {

  render () {
    const { bg, text1, text2, visible } = this.props
    return (
      <CSSTransitionGroup
        transitionName='bo_curtains'
        transitionEnterTimeout={2500}
        transitionLeaveTimeout={1450}
      >
        {visible &&
          <div className='bo_curtains'>
            <div className='bo_curtains__door-wrap bo_curtains__door-wrap--left'>
              <div
                className='bo_curtains__door-left'
                style={{ backgroundImage: `url(${bg})` }} />
            </div>
            <div className='bo_curtains__door-wrap bo_curtains__door-wrap--right'>
              <div
                className='bo_curtains__door-right'
                style={{ backgroundImage: `url(${bg})` }} />
            </div>

            <div id='bo_curtains__bg' className='bo_curtains__bg' style={{ backgroundImage: `url(${bg})` }} />

            <div className='bo_curtains__content'>
              <div id='bo_curtains__text1' className='bo_curtains__text bo_curtains__text--1'>
                {text1}
              </div>
              <div id='bo_curtains__text2' className='bo_curtains__text bo_curtains__text--2'>
                {text2}
              </div>
            </div>
          </div>
        }
      </CSSTransitionGroup>
    )
  }

  static propTypes = {
    bg: PropTypes.string,
    text1: PropTypes.string,
    text2: PropTypes.string,
    visible: PropTypes.bool
  }
}



// WEBPACK FOOTER //
// ./src/templates/bouncy/components/curtains/CurtainsScene.js